import React from 'react';

const TemperatureSettingsTable = () => {
  return (
    <div
      className="table-container"
      style={{
        margin: '30px auto',
        padding: '20px',
        maxWidth: '800px',
        backgroundColor: '#f8f9fa', // light background
        borderRadius: '8px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      }}
    >
      <table
        style={{
          width: '100%',
          borderCollapse: 'collapse',
          backgroundColor: '#ffffff', // white background for the table
          borderRadius: '8px',
          overflow: 'hidden',
          border: '1px solid #ddd',  // Border around the entire table
        }}
      >
        <thead>
          <tr
            style={{
              backgroundColor: '#007BFF', // blue header color
              color: '#fff', // white text for the header
              textAlign: 'center',
              borderBottom: '2px solid #ddd', // Border below header row
            }}
          >
            <th style={{ padding: '12px' }}>Specification</th>
            <th style={{ padding: '12px' }}>Details</th>
          </tr>
        </thead>
        <tbody>
          <tr
            style={{
              textAlign: 'center',
              borderBottom: '1px solid #ddd',  // Border between rows
              backgroundColor: '#f1f8ff', // light blue background for rows
            }}
          >
            <td style={{ padding: '12px' }}>Temperature Unit</td>
            <td style={{ padding: '12px' }}>Celsius (℃), Fahrenheit (℉)</td>
          </tr>
          <tr
            style={{
              textAlign: 'center',
              borderBottom: '1px solid #ddd',  // Border between rows
            }}
          >
            <td style={{ padding: '12px' }}>Fast Temperature Setting</td>
            <td style={{ padding: '12px' }}>
              35℃/95.0℉, 37℃/98.6℉, 39℃/102.2℉, 41℃/105.8℉
            </td>
          </tr>
          <tr
            style={{
              textAlign: 'center',
              borderBottom: '1px solid #ddd',  // Border between rows
              backgroundColor: '#f1f8ff', // light blue background for rows
            }}
          >
            <td style={{ padding: '12px' }}>Unique Air Volume Level</td>
            <td style={{ padding: '12px' }}>Level 1-8 adjustable</td>
          </tr>
          <tr
            style={{
              textAlign: 'center',
              borderBottom: '1px solid #ddd',  // Border between rows
            }}
          >
            <td style={{ padding: '12px' }}>Temperature Control Accuracy</td>
            <td style={{ padding: '12px' }}>±1℃ or ±1.8℉</td>
          </tr>
          <tr
            style={{
              textAlign: 'center',
              borderBottom: '1px solid #ddd',  // Border between rows
              backgroundColor: '#f1f8ff', // light blue background for rows
            }}
          >
            <td style={{ padding: '12px' }}>Warm-up Time</td>
            <td style={{ padding: '12px' }}>≤ 4 minutes</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default TemperatureSettingsTable;
